import { render } from "./StockExpiryReport.vue?vue&type=template&id=809acdd0&ts=true"
import script from "./StockExpiryReport.vue?vue&type=script&lang=ts"
export * from "./StockExpiryReport.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__